/* assets/bundle-builder.js
   Solely Jane Bundle Builder — continuous-scroll Base/Tops/Review flow.
   Real Shopify catalog data (rendered server-side by snippets/bundle-builder-data.liquid)
   + real cart integration. Pricing math mirrors Design Brief Section 4
   exactly and MUST be kept in sync with the sj-bundle-app discount Function's merchant
   settings (Discounts -> "Solely Jane Bundle Pricing") if those numbers ever change —
   this file's `PRICING` block does not read that app's config live.

   NOTE: this is the display/preview math shown while building the bundle. The actual
   charged price at checkout is enforced server-side by the sj-bundle-app Shopify
   Function once it is cut over to this store (see project task "Bundle pricing app
   cutover to live store" — as of 2026-07-24 that app has 0 installs anywhere, so
   no automatic discount is currently applied at checkout for either shop).

   Cart grouping: every item added by a single "Add Bundle to Cart" click is tagged
   with a shared hidden line-item property (_bundle_id) plus a _bundle_role (base/top).
   snippets/cart-line-items.liquid reads _bundle_id to visually wrap the whole bundle
   as one set in the cart drawer/checkout (Design Brief Section 6: "grouped set, not
   a flat list of unrelated SKUs"). Properties starting with "_" are already hidden
   from the customer-facing property display by the theme's own convention.

   Out-of-stock-for-selected-size warning (added 2026-07-24): once the
   customer has picked a size on any base, the Tops grid cross-checks every
   top's colors against that size and (a) dims/flags swatches that are out of
   stock in that size, and (b) shows an explicit warning banner on a card
   when its currently-active color is unavailable in the selected size(s).
   See selectedBaseSizes()/oosSizesForColor() below.
*/
(function () {
  'use strict';

  var root = document.getElementById('bundle-builder');
  if (!root) return;

  var shoeType = root.dataset.shoeType || 'heel';
  var cartAddUrl = root.dataset.cartAddUrl || '/cart/add.js';
  var zoomIcon = root.dataset.zoomIcon || '';

  var dataScript = document.getElementById('bundle-builder-data-' + shoeType);
  if (!dataScript) return;

  var DATA = JSON.parse(dataScript.textContent);
  var PRICING = DATA.pricing; // cents
  var FREE_SHIP_MIN = 15000; // $150, in cents — matches promo bar copy + design source

  // ---------- DOM refs ----------
  var $baseCards = root.querySelector('[data-bb-base-cards]');
  var $baseGuard = root.querySelector('[data-bb-base-guard]');
  var $baseSizeWrap = root.querySelector('[data-bb-base-size-wrap]');
  var $baseSizes = root.querySelector('[data-bb-base-sizes]');
  var $topsGrid = root.querySelector('[data-bb-tops-grid]');
  var $topsBanner = root.querySelector('[data-bb-tops-banner]');
  var $topsSocial = root.querySelector('[data-bb-tops-social]');
  var $reviewCard = root.querySelector('[data-bb-review-card]');
  var $reviewMissingBox = root.querySelector('[data-bb-review-missingbox]');
  var $reviewReadyBox = root.querySelector('[data-bb-review-readybox]');
  var $reviewVariations = root.querySelector('[data-bb-review-variations]');
  var $addToCartBtn = root.querySelector('[data-bb-add-to-cart]');
  var $railSummary = root.querySelector('[data-bb-rail-summary]');
  var $railItems = root.querySelector('[data-bb-rail-items]');
  var $railCounter = root.querySelector('[data-bb-rail-counter]');
  var $railTotal = root.querySelector('[data-bb-rail-total]');
  var $railPpl = root.querySelector('[data-bb-rail-ppl]');
  var $railShipOk = root.querySelector('[data-bb-rail-shipok]');
  var $railShipProg = root.querySelector('[data-bb-rail-shipprog]');
  var $railNudges = root.querySelector('[data-bb-rail-nudges]');
  var $dockPpl = root.querySelector('[data-bb-dock-ppl]');
  var $dockSubtotal = root.querySelector('[data-bb-dock-subtotal]');
  var $lightbox = root.querySelector('[data-bb-lightbox]');
  var $lightboxImg = root.querySelector('[data-bb-lightbox-img]');
  var $toast = root.querySelector('[data-bb-toast]');
  var $progressSteps = root.querySelectorAll('[data-bb-progress] [data-bb-jump]');

  // ---------- State ----------
  var state = {
    bases: [], // { color, product, size, variantId }
    tops: [], // { uid, handle, product, colorName, hasColor, size, variantId, image }
    cardColor: {}, // handle -> active color name
    baseGuardFired: false,
    autoScrolledToTops: false // fires once, the first time a base actually gets a size
  };

  var uidCounter = 0;
  function uid() { return 'bb' + (++uidCounter); }

  function money(cents) {
    return '$' + (cents / 100).toFixed(cents % 100 === 0 ? 0 : 2);
  }

  // ---------- Helpers over catalog data ----------
  function colorsForTop(product) {
    if (!product.hasColor) return [product.title];
    var idx = product.optionNames.indexOf('Color');
    var seen = [];
    product.variants.forEach(function (v) {
      var val = idx === 0 ? v.option1 : v.option2;
      if (val && seen.indexOf(val) === -1) seen.push(val);
    });
    return seen;
  }

  function sizesForTop(product, colorName) {
    if (!product.hasColor) {
      return product.variants.map(function (v) { return v.option1; });
    }
    var colorIdx = product.optionNames.indexOf('Color');
    var sizeIdx = colorIdx === 0 ? 1 : 0;
    return product.variants
      .filter(function (v) {
        var val = colorIdx === 0 ? v.option1 : v.option2;
        return val === colorName;
      })
      .map(function (v) { return sizeIdx === 0 ? v.option1 : v.option2; });
  }

  function variantFor(product, colorName, size) {
    var colorIdx = product.hasColor ? product.optionNames.indexOf('Color') : -1;
    return product.variants.find(function (v) {
      if (!product.hasColor) return v.option1 === size;
      var color = colorIdx === 0 ? v.option1 : v.option2;
      var sz = colorIdx === 0 ? v.option2 : v.option1;
      return color === colorName && sz === size;
    });
  }

  function selectedBaseSizes() {
    // Every distinct size across the customer's currently-selected base(s).
    // Used to flag Top options that are out of stock for the size(s) they've
    // already committed to on the Base step.
    var sizes = [];
    state.bases.forEach(function (b) {
      if (b.size && sizes.indexOf(b.size) === -1) sizes.push(b.size);
    });
    return sizes;
  }

  function oosSizesForColor(product, colorName, sizes) {
    // Which of the given base size(s) is this Top color NOT available in?
    return sizes.filter(function (size) {
      var v = variantFor(product, colorName, size);
      return !v || !v.available;
    });
  }

  function imageForTop(product, colorName, baseColor) {
    if (!product.hasColor) return product.leadImage;
    var v = product.variants.find(function (v2) {
      var colorIdx = product.optionNames.indexOf('Color');
      var color = colorIdx === 0 ? v2.option1 : v2.option2;
      return color === colorName;
    });
    if (!v) return product.leadImage;
    // Show the top on whichever base the customer has selected (2026-07-24
    // spec: main Top images should reflect the selected base; if 2 bases are
    // selected, show it on the 2nd one — see activePreviewBaseColor()).
    // Falls back to the plain top-only studio shot for any color/base combo
    // that doesn't have its own on-base photography yet.
    if (baseColor === 'Black' && v.onBlackBaseImage) return v.onBlackBaseImage;
    if (baseColor === 'Brown' && v.onBrownBaseImage) return v.onBrownBaseImage;
    return v.image || product.leadImage;
  }

  function activePreviewBaseColor() {
    // Which base should Top preview images be shown on? The customer's most
    // recently selected base — i.e. if only one base is chosen, that one; if
    // both are chosen, the 2nd one selected (per spec: "if they select both
    // bases it should show on the 2nd selected base"). state.bases is always
    // appended in selection order, so the last entry is "most recent."
    if (!state.bases.length) return null;
    return state.bases[state.bases.length - 1].color;
  }

  function displayTitle(title) {
    return title.replace(/-\s*(Flats\s*)?Top Only\s*$/i, '').trim();
  }

  // ---------- Pricing engine (Design Brief Section 4) ----------
  function calcTotal(nBases, nTops) {
    if (nBases === 0) return 0;
    var baseCost = PRICING.basePrice + Math.max(nBases - 1, 0) * PRICING.secondBasePrice;
    if (nTops < 2) {
      return baseCost + nTops * PRICING.topPrice;
    }
    var extraBaseCost = baseCost - PRICING.basePrice; // cost of bases beyond the 1st
    var remainingTops = nTops - 2;
    var topsAt30 = Math.min(remainingTops, 2) * PRICING.midTierTopPrice;
    var topsAt25 = Math.max(remainingTops - 2, 0) * PRICING.volumeTopPrice;
    return PRICING.packagePrice + extraBaseCost + topsAt30 + topsAt25;
  }

  function regularTotal(nBases, nTops) {
    return nBases * PRICING.basePrice + nTops * PRICING.topPrice;
  }

  function nextTopPrice(nTops) {
    // price the *next* top add would cost, once >=2 tops already in bundle
    if (nTops < 2) return PRICING.topPrice;
    if (nTops < 4) return PRICING.midTierTopPrice;
    return PRICING.volumeTopPrice;
  }

  function currentMetrics() {
    var nBases = state.bases.length;
    var nTops = state.tops.length;
    var total = calcTotal(nBases, nTops);
    var regular = regularTotal(nBases, nTops);
    var variations = nBases * nTops;
    var ppl = variations > 0 ? Math.round(total / variations) : null;
    var saved = regular - total;
    return { nBases: nBases, nTops: nTops, total: total, regular: regular, variations: variations, ppl: ppl, saved: saved };
  }

  // ---------- Rendering: Base ----------
  function renderBaseCards() {
    $baseCards.innerHTML = '';
    DATA.bases.forEach(function (base) {
      var added = state.bases.find(function (b) { return b.color === base.color; });
      var otherAdded = state.bases.length === 1 && !added;

      var card = document.createElement('div');
      card.className = 'bb-base-card' + (added ? ' is-selected' : '') + (otherAdded ? ' is-deal' : '');

      var priceHtml;
      if (otherAdded) {
        priceHtml = '<s>' + money(PRICING.basePrice) + '</s> ' + money(PRICING.secondBasePrice);
      } else {
        priceHtml = money(PRICING.basePrice);
      }

      card.innerHTML =
        '<img src="' + base.image + '" alt="' + base.color + ' base">' +
        '<div class="bb-base-card__badge">&#10003;</div>' +
        '<div class="bb-base-card__row">' +
          '<span class="bb-base-card__colorLabel"><span class="bb-base-card__dot" style="background:' + swatchHex(base.color) + '"></span>' + base.color + '</span>' +
          '<span class="bb-base-card__price">' + priceHtml + '</span>' +
        '</div>' +
        (otherAdded ? '<div class="bb-base-card__deal">Add this base for just ' + money(PRICING.secondBasePrice) + ' — save 50%!</div>' : '');

      card.addEventListener('click', function () {
        var existingBase = state.bases.find(function (b) { return b.color === base.color; });
        if (existingBase) {
          removeBase(base.color);
        } else {
          selectBase(base);
        }
      });

      $baseCards.appendChild(card);
    });
  }

  function activeSizingBase() {
    for (var i = state.bases.length - 1; i >= 0; i--) {
      if (!state.bases[i].size) return state.bases[i];
    }
    return state.bases[0] || null;
  }

  function renderBaseSize() {
    var active = activeSizingBase();
    if (!active) {
      $baseSizeWrap.hidden = true;
      return;
    }
    $baseSizeWrap.hidden = false;
    $baseSizes.innerHTML = '';
    active.product.variants.forEach(function (v) {
      if (!v.available) return;
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'bb-size-chip' + (active.size === v.size ? ' is-selected' : '');
      chip.textContent = v.size;
      chip.addEventListener('click', function () {
        setBaseSize(active.color, v.size, v.id);
      });
      $baseSizes.appendChild(chip);
    });
  }

  function selectBase(base) {
    // Selecting a base color only adds it and reveals the size picker — it
    // must NOT auto-scroll away before the customer has had a chance to pick
    // a size. The scroll-to-tops nudge happens in setBaseSize() instead, once
    // a size is actually chosen (see comment there).
    var existing = state.bases.find(function (b) { return b.color === base.color; });
    if (existing) return; // already added
    state.bases.push({ color: base.color, product: base, size: null, variantId: null });
    $baseGuard.hidden = true;
    renderAll();
  }

  function setBaseSize(color, size, variantId) {
    var b = state.bases.find(function (b2) { return b2.color === color; });
    if (!b) return;
    var hadAnySizeBefore = state.bases.some(function (b2) { return b2.size; });
    b.size = size;
    b.variantId = variantId;
    renderAll();
    // Advance to Tops the first time a base size is actually picked — not on
    // base-color selection (that was the bug: it used to snap down before the
    // customer could pick a size). Fires once per session.
    if (!hadAnySizeBefore && !state.autoScrolledToTops) {
      state.autoScrolledToTops = true;
      scrollToSection('tops');
    }
  }

  // ---------- Rendering: Tops ----------
  function renderTopsGrid() {
    var m = currentMetrics();
    $topsBanner.hidden = m.nTops >= 2;
    $topsSocial.hidden = m.nTops < 2;

    var baseSizes = selectedBaseSizes();
    var previewBaseColor = activePreviewBaseColor();

    $topsGrid.innerHTML = '';
    DATA.tops.forEach(function (product) {
      var colors = colorsForTop(product);
      var activeColor = state.cardColor[product.handle] || colors[0];
      var image = imageForTop(product, activeColor, previewBaseColor);
      var addedCount = state.tops.filter(function (t) { return t.handle === product.handle; }).length;
      var activeColorOosSizes = baseSizes.length ? oosSizesForColor(product, activeColor, baseSizes) : [];

      var card = document.createElement('div');
      card.className = 'bb-top-card';

      var priceLine = '';
      if (m.nTops >= 2) {
        priceLine = '<s>' + money(PRICING.topPrice) + '</s> ' + money(nextTopPrice(m.nTops));
      }

      var zoomInner = zoomIcon
        ? '<img src="' + zoomIcon + '" alt="" width="38" height="38">'
        : '&#128269;';

      var stockWarningHtml = activeColorOosSizes.length
        ? '<div class="bb-top-card__stockWarning"><span class="bb-top-card__stockWarning-icon" aria-hidden="true">&#9888;</span>Out of stock in your selected base size' +
          (activeColorOosSizes.length > 1 ? 's' : '') + ' (US ' + activeColorOosSizes.join(', US ') + ')</div>'
        : '';

      card.innerHTML =
        '<div class="bb-top-card__imgWrap">' +
          '<img src="' + image + '" alt="' + product.title + '">' +
          '<button type="button" class="bb-top-card__zoom" data-zoom aria-label="View larger">' + zoomInner + '</button>' +
          (addedCount > 0 ? '<span class="bb-top-card__count">' + addedCount + '</span>' : '') +
        '</div>' +
        '<div class="bb-top-card__body">' +
          '<div class="bb-top-card__row">' +
            '<span class="bb-top-card__name">' + displayTitle(product.title) + '</span>' +
            (priceLine ? '<span class="bb-top-card__price">' + priceLine + '</span>' : '') +
          '</div>' +
          '<div class="bb-top-card__colorLabel">Color: ' + activeColor + '</div>' +
          '<div class="bb-swatches" data-swatches></div>' +
          stockWarningHtml +
          '<button type="button" class="bb-top-card__add" data-add>Add to Bundle</button>' +
        '</div>';

      var swatchRow = card.querySelector('[data-swatches]');
      colors.forEach(function (colorName) {
        var sw = document.createElement('button');
        sw.type = 'button';
        var swOosSizes = baseSizes.length ? oosSizesForColor(product, colorName, baseSizes) : [];
        var isOos = swOosSizes.length > 0;
        sw.className = 'bb-swatch' + (colorName === activeColor ? ' is-active' : '') + (isOos ? ' is-oos' : '');
        sw.style.background = swatchHex(colorName);
        sw.title = isOos ? (colorName + ' — out of stock in US ' + swOosSizes.join(', US ')) : colorName;
        sw.addEventListener('click', function () {
          state.cardColor[product.handle] = colorName;
          renderTopsGrid();
        });
        swatchRow.appendChild(sw);
      });

      card.querySelector('[data-zoom]').addEventListener('click', function () {
        var gallery = (product.images && product.images.length) ? product.images : [image];
        var startIdx = gallery.indexOf(image);
        if (startIdx === -1) startIdx = 0;
        openLightbox(gallery, startIdx);
      });

      card.querySelector('[data-add]').addEventListener('click', function () {
        addTop(product, activeColor);
      });

      $topsGrid.appendChild(card);
    });
  }

  var SWATCH_HEX = {
    'Black': '#000000', 'Brown': '#5a3825', 'Snake': '#a5958f', 'Tan': '#c9a577',
    'Grey': '#9a9a9a', 'Pink': '#f2b8c6', 'Navy': '#1f2b47', 'Cinnamon': '#a66e38',
    'White': '#fafafa', 'Light Brown': '#e5ba73', 'Etherea': '#a5958f',
    'Tiger Print': '#bf6c31', 'Rouge': '#a23b6c', 'Forest Green': '#002d04',
    'Sage': '#b2ac88', 'Walnut': '#773f1a', 'Canary': '#fff88f', 'Lilac': '#c8a2c8',
    'Onyx': '#111111', 'Ivory': '#f4ecd8', 'Violet': '#6f4e8c', 'Salmon': '#f19c8a'
  };
  function swatchHex(name) { return SWATCH_HEX[name] || '#cccccc'; }

  function addTop(product, colorName) {
    if (state.bases.length === 0) {
      if (!state.baseGuardFired) {
        state.baseGuardFired = true;
        $baseGuard.hidden = false;
        scrollToSection('base');
      }
      return;
    }
    $baseGuard.hidden = true;

    var suggestedSize = state.bases[0].size || null;
    var image = imageForTop(product, colorName, activePreviewBaseColor());
    var item = {
      uid: uid(),
      handle: product.handle,
      title: displayTitle(product.title),
      product: product,
      colorName: colorName,
      hasColor: !!product.hasColor,
      size: suggestedSize,
      variantId: suggestedSize ? (variantFor(product, colorName, suggestedSize) || {}).id : null,
      image: image
    };
    state.tops.push(item);
    renderAll();
    showToast(item.title + (item.hasColor ? ' (' + colorName + ')' : '') + ' added');
  }

  function removeTop(itemUid) {
    state.tops = state.tops.filter(function (t) { return t.uid !== itemUid; });
    renderAll();
  }

  function removeBase(color) {
    state.bases = state.bases.filter(function (b) { return b.color !== color; });
    renderAll();
  }

  function setTopSize(itemUid, size) {
    var item = state.tops.find(function (t) { return t.uid === itemUid; });
    if (!item) return;
    item.size = size;
    item.variantId = (variantFor(item.product, item.colorName, size) || {}).id;
    renderAll();
  }

  // ---------- Rendering: Review ----------
  function compactSizeChipsHtml(variants, currentSize, kind, key) {
    return variants.filter(function (v) { return v.available; }).map(function (v) {
      var sel = currentSize === v.size ? ' is-selected' : '';
      return '<button type="button" class="bb-size-chip bb-size-chip--compact' + sel + '" data-review-chip data-kind="' + kind + '" data-key="' + key + '" data-size="' + v.size + '" data-variant="' + v.id + '">' + v.size + '</button>';
    }).join('');
  }

  function renderReview() {
    var m = currentMetrics();
    var html = '';

    state.bases.forEach(function (b, i) {
      var isSecond = i === 1;
      var subtitle = isSecond ? 'Your 2nd color — swap tops onto either base' : 'Your reusable comfort foundation';
      var priceHtml = isSecond
        ? '<s>' + money(PRICING.basePrice) + '</s> ' + money(PRICING.secondBasePrice)
        : money(PRICING.basePrice);
      html +=
        '<div class="bb-review__baseRow">' +
          '<div class="bb-review__thumb"><img src="' + b.product.image + '" alt="' + b.color + ' base"></div>' +
          '<div class="bb-review__baseInfo">' +
            '<div class="bb-review__baseName">' + (shoeType === 'flat' ? 'Flats' : 'Heels') + ' Base — ' + b.color + '</div>' +
            '<div class="bb-review__baseSub">' + subtitle + '</div>' +
            '<div class="bb-size-chips bb-size-chips--compact">' + compactSizeChipsHtml(b.product.variants, b.size, 'base', b.color) + '</div>' +
          '</div>' +
          '<div class="bb-review__basePrice">' + priceHtml + '</div>' +
        '</div>';
    });

    if (state.tops.length) {
      html += '<div class="bb-review__topsLabel">YOUR TOPS (' + state.tops.length + ')</div>';
      state.tops.forEach(function (t) {
        var sizes = sizesForTop(t.product, t.colorName);
        var chipsHtml = sizes.map(function (s) {
          var v = variantFor(t.product, t.colorName, s);
          if (v && !v.available) return '';
          var sel = t.size === s ? ' is-selected' : '';
          return '<button type="button" class="bb-size-chip bb-size-chip--compact' + sel + '" data-review-chip data-kind="top" data-key="' + t.uid + '" data-size="' + s + '" data-variant="' + (v ? v.id : '') + '">' + s + '</button>';
        }).join('');
        html +=
          '<div class="bb-review__topRow">' +
            '<div class="bb-review__thumb bb-review__thumb--sm"><img src="' + t.image + '" alt="' + t.title + '"></div>' +
            '<div class="bb-review__topInfo">' +
              '<div class="bb-review__topHead">' +
                '<span class="bb-review__topName">' + t.title + '</span>' +
                '<span class="bb-review__topPrice">' + money(PRICING.topPrice) + '</span>' +
              '</div>' +
              (t.hasColor ? '<div class="bb-review__topSub">Color: ' + t.colorName + '</div>' : '') +
              '<div class="bb-size-chips bb-size-chips--compact">' + chipsHtml + '</div>' +
            '</div>' +
            '<button type="button" class="bb-review__remove" data-remove-top="' + t.uid + '" aria-label="Remove">&times;</button>' +
          '</div>';
      });
    }

    if (m.saved > 0) {
      html +=
        '<div class="bb-review__savings">' +
          '<div class="bb-review__savingsRow"><span>Regular price</span><span class="bb-review__strike">' + money(m.regular) + '</span></div>' +
          '<div class="bb-review__savingsRow bb-review__savingsRow--save"><span>Bundle savings</span><span>−' + money(m.saved) + '</span></div>' +
          '<div class="bb-review__savingsRow bb-review__savingsRow--total"><span>Bundle total</span><span>' + money(m.total) + '</span></div>' +
        '</div>';
    }

    $reviewCard.innerHTML = html;

    $reviewCard.querySelectorAll('[data-review-chip]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var kind = chip.getAttribute('data-kind');
        var key = chip.getAttribute('data-key');
        var size = chip.getAttribute('data-size');
        var variantId = chip.getAttribute('data-variant');
        if (kind === 'base') {
          setBaseSize(key, size, variantId || null);
        } else {
          setTopSize(key, size);
        }
      });
    });
    $reviewCard.querySelectorAll('[data-remove-top]').forEach(function (btn) {
      btn.addEventListener('click', function () { removeTop(btn.getAttribute('data-remove-top')); });
    });

    // ---- "what's still missing" checklist (exact copy from design source) ----
    var missing = [];
    if (!state.bases.length) missing.push('Choose a base color');
    else if (!state.bases[0].size) missing.push('Pick a base size');
    if (m.nTops < 2) missing.push('Add ' + (2 - m.nTops) + ' more top' + ((2 - m.nTops) > 1 ? 's' : '') + ' (2 minimum)');
    var unsized = state.tops.filter(function (t) { return t.size == null; }).length;
    if (unsized > 0) missing.push('Pick a size for ' + unsized + ' top' + (unsized > 1 ? 's' : ''));

    var ready = missing.length === 0;

    $reviewMissingBox.hidden = missing.length === 0;
    if (missing.length) {
      $reviewMissingBox.innerHTML =
        '<div class="bb-review__missingTitle">A few things left before checkout:</div>' +
        '<div class="bb-review__missingList">' +
          missing.map(function (msg) { return '<span class="bb-review__missingItem"><span class="bb-review__missingDot"></span>' + msg + '</span>'; }).join('') +
        '</div>';
    }
    $reviewReadyBox.hidden = !ready;

    $addToCartBtn.disabled = !ready;
    $addToCartBtn.textContent = 'Checkout' + (m.total ? ' · ' + money(m.total) : '');

    // ---- price-per-look + nudges box ----
    if (m.variations > 0) {
      $reviewVariations.hidden = false;
      var lines = '<div class="bb-review__variationsLine">You’ll have ' + m.variations + ' shoe style' + (m.variations === 1 ? '' : 's') + ' for ' + money(m.ppl) + ' each</div>';
      if (m.saved > 0) lines += '<div class="bb-review__variationsNote bb-review__variationsNote--saved">You’ve saved ' + money(m.saved) + ' on your starter set</div>';
      var freeShipUnlocked = m.total >= FREE_SHIP_MIN;
      if (freeShipUnlocked) {
        lines += '<div class="bb-review__variationsNote">🚚 Free shipping unlocked on this order!</div>';
      } else if (m.total > 0) {
        lines += '<div class="bb-review__variationsNote">🚚 Add ' + money(FREE_SHIP_MIN - m.total) + ' more to unlock FREE shipping</div>';
      }
      if (m.nBases >= 1 && m.nBases < 2) {
        var baseNudgeText = m.nTops >= 1
          ? ('Add a second base to double your styles and bring your price per look down to ' + money(Math.round((m.total + PRICING.secondBasePrice) / (m.nTops * 2))) + '.')
          : 'Add a second base to double your styles — swap tops onto either color.';
        lines += '<div class="bb-review__variationsNote bb-review__variationsNote--pink">➕ ' + baseNudgeText + '</div>';
      }
      if (m.nTops >= 2) {
        var baseCountForProj = m.nBases || 1;
        var topNudgeText;
        if (m.nTops >= 4) {
          var projMoreTops = Math.round((m.total + PRICING.volumeTopPrice * 2) / (baseCountForProj * (m.nTops + 2)));
          topNudgeText = 'Tops are now just ' + money(PRICING.volumeTopPrice) + ' each — add more to bring your price per look down to ' + money(projMoreTops) + '.';
        } else {
          var projTo4 = Math.round((m.total + PRICING.midTierTopPrice * 2) / (baseCountForProj * (m.nTops + 2)));
          topNudgeText = m.nTops === 3
            ? ('Your 4th top is only ' + money(PRICING.midTierTopPrice) + ' — add it to bring your price per look down to ' + money(projTo4) + '.')
            : ('The next 2 tops you add are only ' + money(PRICING.midTierTopPrice) + ' each — add them now to bring your price per look down to ' + money(projTo4) + '.');
        }
        lines += '<div class="bb-review__variationsNote">' + topNudgeText + '</div>';
      }
      $reviewVariations.innerHTML = lines;
    } else {
      $reviewVariations.hidden = true;
    }
  }

  // ---------- Rendering: Rail / Dock ----------
  function railSummaryLine(m) {
    if (!state.bases.length) return 'Choose your base to begin';
    var modeLabel = shoeType === 'flat' ? 'Flats' : 'Heels';
    var baseBits = state.bases.map(function (b) {
      return b.color + (b.size ? ' (US ' + b.size + ')' : '');
    }).join(' + ');
    var line = modeLabel + ' base · ' + baseBits;
    if (m.nTops) line += ' · ' + m.nTops + ' item' + (m.nTops > 1 ? 's' : '');
    return line;
  }

  function renderRailItems() {
    $railItems.innerHTML = '';
    state.bases.forEach(function (b) {
      var row = document.createElement('div');
      row.className = 'bb-rail__item';
      row.innerHTML =
        '<img src="' + b.product.image + '" alt="">' +
        '<div class="bb-rail__item-info"><div class="bb-rail__item-name">Base — ' + b.color + '</div>' +
        '<div class="bb-rail__item-color">' + (b.size ? 'US ' + b.size : 'Pick a size') + '</div></div>' +
        '<button type="button" aria-label="Remove">&times;</button>';
      row.querySelector('button').addEventListener('click', function () { removeBase(b.color); });
      $railItems.appendChild(row);
    });
    state.tops.forEach(function (t) {
      var row = document.createElement('div');
      row.className = 'bb-rail__item';
      row.innerHTML =
        '<img src="' + t.image + '" alt="">' +
        '<div class="bb-rail__item-info"><div class="bb-rail__item-name">' + t.title + '</div>' +
        '<div class="bb-rail__item-color">' + (t.hasColor ? t.colorName : '') + (t.size ? ' · ' + t.size : '') + '</div></div>' +
        '<button type="button" aria-label="Remove">&times;</button>';
      row.querySelector('button').addEventListener('click', function () { removeTop(t.uid); });
      $railItems.appendChild(row);
    });
  }

  function renderRailNudges(m) {
    var html = '';
    if (m.nBases >= 1 && m.nBases < 2) {
      var text;
      if (m.nTops >= 1) {
        var projSecondBase = Math.round((m.total + PRICING.secondBasePrice) / (m.nTops * 2));
        text = 'Add a second base to double your styles and bring your price per look down to ' + money(projSecondBase) + '.';
      } else {
        text = 'Add a second base to double your styles — swap tops onto either color.';
      }
      html += '<div class="bb-rail__nudge--base">➕ ' + text + '</div>';
    }
    if (m.nTops >= 2) {
      var baseCountForProj = m.nBases || 1;
      var topText;
      if (m.nTops >= 4) {
        var projMoreTops = Math.round((m.total + PRICING.volumeTopPrice * 2) / (baseCountForProj * (m.nTops + 2)));
        topText = 'Tops are now just ' + money(PRICING.volumeTopPrice) + ' each — add more to bring your price per look down to ' + money(projMoreTops) + '.';
      } else {
        var projTo4 = Math.round((m.total + PRICING.midTierTopPrice * 2) / (baseCountForProj * (m.nTops + 2)));
        if (m.nTops === 3) {
          topText = 'Your 4th top is only ' + money(PRICING.midTierTopPrice) + ' — add it to bring your price per look down to ' + money(projTo4) + '.';
        } else {
          topText = 'The next 2 tops you add are only ' + money(PRICING.midTierTopPrice) + ' each — add them now to bring your price per look down to ' + money(projTo4) + '.';
        }
      }
      html += '<div class="bb-rail__nudge--top">' + topText + '</div>';
    }
    $railNudges.innerHTML = html;
  }

  function renderRail() {
    var m = currentMetrics();

    $railSummary.textContent = railSummaryLine(m);
    renderRailItems();

    $railCounter.hidden = false;
    $railCounter.innerHTML = 'Items: ' + m.nTops + ' <span class="bb-rail__counter-min">min 2</span>';

    $railTotal.textContent = money(m.total);
    $dockSubtotal.textContent = money(m.total);

    if (m.variations > 0) {
      $railPpl.hidden = false;
      $railPpl.innerHTML =
        '<div class="bb-rail__ppl-line">You currently have ' + m.variations + ' shoe style' + (m.variations === 1 ? '' : 's') + ' for ' + money(m.ppl) + ' each</div>' +
        (m.saved > 0 ? '<div class="bb-rail__ppl-saved">You’ve saved ' + money(m.saved) + ' so far</div>' : '');
      $dockPpl.textContent = money(m.ppl) + '/look';
    } else {
      $railPpl.hidden = true;
      $dockPpl.textContent = '';
    }

    var freeShipUnlocked = m.total >= FREE_SHIP_MIN;
    $railShipOk.hidden = !freeShipUnlocked;
    if (freeShipUnlocked) $railShipOk.innerHTML = '🚚 Free shipping unlocked on this order!';

    var showShipProgress = !freeShipUnlocked && m.total > 0;
    $railShipProg.hidden = !showShipProgress;
    if (showShipProgress) $railShipProg.innerHTML = '🚚 Add ' + money(FREE_SHIP_MIN - m.total) + ' more to unlock FREE shipping';

    renderRailNudges(m);
  }

  // ---------- Lightbox ----------
  var $lightboxPrev = root.querySelector('[data-bb-lightbox-prev]');
  var $lightboxNext = root.querySelector('[data-bb-lightbox-next]');
  var $lightboxClose = root.querySelector('[data-bb-lightbox-close]');
  var lightboxImages = [];
  var lightboxIndex = 0;

  function renderLightboxImage() {
    if (!lightboxImages.length) return;
    $lightboxImg.src = lightboxImages[lightboxIndex];
    var multi = lightboxImages.length > 1;
    $lightboxPrev.hidden = !multi;
    $lightboxNext.hidden = !multi;
  }

  function openLightbox(images, startIndex) {
    lightboxImages = (images && images.length) ? images : [];
    lightboxIndex = startIndex || 0;
    renderLightboxImage();
    $lightbox.hidden = false;
  }

  function closeLightbox() { $lightbox.hidden = true; }

  function lightboxPrev() {
    if (lightboxImages.length < 2) return;
    lightboxIndex = (lightboxIndex - 1 + lightboxImages.length) % lightboxImages.length;
    renderLightboxImage();
  }

  function lightboxNext() {
    if (lightboxImages.length < 2) return;
    lightboxIndex = (lightboxIndex + 1) % lightboxImages.length;
    renderLightboxImage();
  }

  $lightboxClose.addEventListener('click', closeLightbox);
  $lightboxPrev.addEventListener('click', lightboxPrev);
  $lightboxNext.addEventListener('click', lightboxNext);
  $lightbox.addEventListener('click', function (e) { if (e.target === $lightbox) closeLightbox(); });
  document.addEventListener('keydown', function (e) {
    if ($lightbox.hidden) return;
    if (e.key === 'Escape') closeLightbox();
    else if (e.key === 'ArrowLeft') lightboxPrev();
    else if (e.key === 'ArrowRight') lightboxNext();
  });

  // ---------- Toast ----------
  var toastTimer;
  function showToast(msg) {
    $toast.textContent = msg;
    $toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { $toast.hidden = true; }, 2200);
  }

  // ---------- Scroll / progress ----------
  function scrollToSection(name) {
    var el = root.querySelector('[data-bb-section="' + name + '"]');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  $progressSteps.forEach(function (btn) {
    btn.addEventListener('click', function () { scrollToSection(btn.getAttribute('data-bb-jump')); });
  });
  root.querySelectorAll('[data-bb-jump="review"]').forEach(function (btn) {
    btn.addEventListener('click', function () { scrollToSection('review'); });
  });

  var sections = ['base', 'tops', 'review'];
  var stepButtons = {};
  document.querySelectorAll('[data-bb-progress] [data-bb-jump]').forEach(function (b) {
    stepButtons[b.getAttribute('data-bb-jump')] = b;
  });
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var name = entry.target.getAttribute('data-bb-section');
        sections.forEach(function (s) {
          if (stepButtons[s]) stepButtons[s].classList.toggle('is-active', s === name);
        });
      }
    });
  }, { threshold: 0.4 });
  sections.forEach(function (s) {
    var el = root.querySelector('[data-bb-section="' + s + '"]');
    if (el) observer.observe(el);
  });

  // ---------- Add to cart -> straight to checkout ----------
  // 2026-07-27: per Jono's request, the Bundle Builder's checkout button now
  // skips the cart drawer AND the cart page entirely — it adds the bundle's
  // line items via the Cart AJAX API (/cart/add.js) and then redirects the
  // browser straight to /checkout the moment the add succeeds. This
  // intentionally does NOT use the theme's <cart-items>.addToCart() /
  // openCartDrawer() controller (used elsewhere, e.g. assets/pdp.js) — that
  // controller's whole job is to open the drawer, which is exactly the step
  // we now want to skip for bundle purchases. A plain fetch() is simpler and
  // more reliable for this "fire and navigate away" flow than fighting the
  // drawer controller's own UI state.
  $addToCartBtn.addEventListener('click', function () {
    if ($addToCartBtn.disabled) return;

    var bundleId = 'bnd_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
    var bundleLabel = shoeType === 'flat' ? 'Your Flats Bundle' : 'Your Heels Bundle';

    var items = [];
    state.bases.forEach(function (b) {
      if (b.variantId) {
        items.push({
          id: idNumber(b.variantId),
          quantity: 1,
          properties: { '_bundle_id': bundleId, '_bundle_role': 'base', '_bundle_label': bundleLabel }
        });
      }
    });
    state.tops.forEach(function (t) {
      if (t.variantId) {
        items.push({
          id: idNumber(t.variantId),
          quantity: 1,
          properties: { '_bundle_id': bundleId, '_bundle_role': 'top', '_bundle_label': bundleLabel }
        });
      }
    });
    if (!items.length) return;

    $addToCartBtn.disabled = true;
    $addToCartBtn.textContent = 'Taking you to checkout...';

    fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw new Error((err && err.description) || 'Cart add failed');
          });
        }
        return res.json();
      })
      .then(function () {
        // Skip the side cart drawer and the /cart page entirely — go
        // straight to checkout with the bundle already in the cart.
        window.location.href = '/checkout';
      })
      .catch(function () {
        showToast('Something went wrong adding to cart — please try again.');
        $addToCartBtn.disabled = false;
        renderReview();
      });
  });

  function idNumber(gidOrNum) {
    if (typeof gidOrNum === 'number') return gidOrNum;
    var m = String(gidOrNum).match(/(\d+)$/);
    return m ? parseInt(m[1], 10) : gidOrNum;
  }

  // ---------- Master render ----------
  function renderAll() {
    renderBaseCards();
    renderBaseSize();
    renderTopsGrid();
    renderReview();
    renderRail();
  }

  renderAll();
})();
